import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { DriverOperationsService, FilterService } from '../../../../../_shared/services';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AccountDateFilterRequest } from '../../../../../_shared/models/account-date-filter-request.model';
import { endOfDay, startOfDay } from 'date-fns';
import { DriversInYardModalComponent } from '../../modals/drivers-in-yard-modal/drivers-in-yard-modal.component';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-drivers-in-yard-widget',
  standalone: true,
  imports: [KpiWidgetComponent, TranslocoPipe],
  templateUrl: './drivers-in-yard-widget.component.html',
  styleUrl: './drivers-in-yard-widget.component.scss',
})
export class DriversInYardWidgetComponent extends BaseWidgetComponent {
  private modalService = inject(NgbModal);
  private driverOperationService = inject(DriverOperationsService);
  private errorHandlerService = inject(ErrorHandlerService);

  hasError: boolean = false;
  errorMessage: string = '';

  currentDate: Date = new Date();
  request: AccountDateFilterRequest = {
    accountIds: [],
    timeFrom: startOfDay(this.currentDate),
    timeTo: endOfDay(this.currentDate)
  };

  constructor() {
    const filterService = inject(FilterService);
    super(filterService);
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.request.accountIds = this.widgetFilter.accountIds;

    await this.getTotalDriversInYard();
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}`;
  }

  public openDriverInYardModal(): void {
    if (this.value === 0) return;
    
    const options: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    };

    const modalRef = this.modalService.open(DriversInYardModalComponent, options);
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.paginationRequest.accountIds = this.widgetFilter.accountIds;
    modalRef.componentInstance.onFilterChangeAsync();
  }

  async getTotalDriversInYard(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;

    try {
      this.cancelSubject.next();
      const response = await this.driverOperationService.getDriversInYardSummary(this.request, this.cancelSubject)
      this.value = response.data?.totalDrivers ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }
}